import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonIcon } from 'src/app/components/Button/ButtonIcon';
import { IconClose } from 'src/app/components/Icon/IconClose';
import { IconContent } from 'src/app/components/Icon/IconContent';
import { IconPlus } from 'src/app/components/Icon/IconPlus';
import { PlaylistCheckbox } from 'src/app/components/Playlist/PlaylistCheckbox';
import { PlaylistCreate } from 'src/app/components/Playlist/PlaylistCreate';
import { GA_EVENT_CATEGORY } from 'src/app/constants/analytics';
import { EventTrack, pushEventTracking } from 'src/app/helpers/analytics';
import { withStyles } from 'src/app/helpers/styles';
import { Playlist } from 'src/app/models/playlist';
import { InjectedToastProps } from 'src/app/models/toast';

type MyInjectedProps = InjectedToastProps;

interface MyOwnProps {
  close: VoidFunction;
  isInWatchlist: boolean;
  inPlaylists: Playlist[];
  userPlaylists: Playlist[];
  videoId: string;
  pushEventTrack?: EventTrack;
}

interface MyState {
  showCreatePlaylist: boolean;
}

type MyProps = MyOwnProps & MyInjectedProps;

@withStyles({
  base: [require('./PopupPlaylist.base.scss')],
  desktop: [require('./PopupPlaylist.desktop.scss')]
})
class MyClassPopupPlaylist extends React.Component<MyProps, MyState> {
  constructor(props: MyProps) {
    super(props);

    this.state = {
      showCreatePlaylist: false
    };

    this.handleShowCreatePlaylist = this.handleShowCreatePlaylist.bind(this);
  }

  render(): JSX.Element {
    return (
      <div onClick={this.handlePopupClick} className="fs-14 py-24 bg-gray-dark position-absolute popup-playlist__container">
        {this.renderHeader}
        <div className="popup-playlist__checkbox-container">
          {this.renderWatchlistCheckbox}
          {this.renderPlaylistCheckBox}
        </div>
        <hr className="bg-gray-lighter mt-16 mx-8 "/>
        {this.renderFooter}
      </div>
    );
  }

  private get renderHeader(): JSX.Element {
    return (
      <div className='ls-2 fs-20 fw-700 fg-white fw-700 d-flex mx-24 mb-16'>
        <span className='flex-1'>
          <FormattedMessage id="label.playlist.add.to" />
        </span>
        <ButtonIcon icon={IconClose} onClick={this.props.close} modifier="transparent" buttonSize='fit-content'/>
      </div>
    );
  }

  private get renderWatchlistCheckbox(): JSX.Element {
    return (
      <PlaylistCheckbox
        key='watchlist'
        id='watchlist'
        name='Watchlist'
        isChecked={this.props.isInWatchlist}
        type='watchlist'
        videoId={this.props.videoId}
        showToast={this.props.showToast}
        pushEventTrack={this.props.pushEventTrack}
      />
    );
  }

  private get renderPlaylistCheckBox(): JSX.Element[] {
    const { inPlaylists, userPlaylists } = this.props;

    return userPlaylists.map((item: Playlist) => {
      const isChecked = inPlaylists.some((element) => element.id === item.id);
      return (
        <PlaylistCheckbox
          key={item.id}
          id={item.id}
          name={item.name}
          isChecked={isChecked}
          type='playlist'
          videoId={this.props.videoId}
          showToast={this.props.showToast}
          pushEventTrack={this.props.pushEventTrack}
        />
      );
    });
  }

  private get renderFooter(): JSX.Element {
    return (
      <div className="mx-16 pt-8">
        {this.state.showCreatePlaylist
          ? <PlaylistCreate
              onCreate={this.props.close}
              showToast={this.props.showToast}
              autoAddVideoId={this.props.videoId}
              pushEventTrack={this.props.pushEventTrack} />
          : <div className="cursor-pointer" onClick={this.handleShowCreatePlaylist}>
            <IconContent classNameIcon="fs-14 fg-gray-light" icon={IconPlus}>
              <FormattedMessage id="label.playlist.create" />
            </IconContent>
          </div>
        }
      </div>
    );
  }

  private handleShowCreatePlaylist(): void {
    this.setState({ showCreatePlaylist: true });
    pushEventTracking(GA_EVENT_CATEGORY.ADD_BUTTON, 'intent to add new playlist');
  }

  private handlePopupClick(e: React.MouseEvent<HTMLDivElement>): void {
    e.stopPropagation();
  }
}

export const PopupPlaylist = MyClassPopupPlaylist as React.ComponentClass<MyProps>;
